
export const host = "https://facepay.vn/page"
